import { createSlotsContext } from "@grandvisionhq/slots";
const [AddressFormSlotsProvider, useAddressFormSlotsContext] = createSlotsContext({
  displayName: "AddressFormSlotsContext"
});
export {
  AddressFormSlotsProvider,
  useAddressFormSlotsContext
};
//# sourceMappingURL=AddressFormSlotsContext.js.map
